"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { initGA, logPageView } from "@/lib/analytics";

const ClientAnalytics = () => {
  const pathname = usePathname();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    logPageView(pathname);
  }, [pathname]);

  return null;
};

export default ClientAnalytics;
